<template>
  <div
    style="
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin-top: 50px;
    "
  >
    <div style="width: 100%">
      <div class="page-title-container">
        <p class="title-container">FINE FATTURAZIONE</p>
      </div>
      <div class="card-container">
        <FineFatturazioneCard />
      </div>
    </div>
  </div>
</template>

<script>
import { useStore } from "vuex";
import FineFatturazioneCard from "../components/FineFatturazioneCard.vue";
export default {
  name: "FineFatturazioneView",
  data() {
    return {};
  },

  setup() {
    const store = useStore();
    return {
      store,
    };
  },

  components: {
    FineFatturazioneCard,
  },
};
</script>

<style scoped>
.page-title-container {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.title-container {
  font-size: 2rem;
  letter-spacing: 2px;
}

.card-container {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
